export default {
    browser_title: "Kevi | Answers",
    page_title: "Answers",
    messages_counter: "{0} of {1} answers",
    empty_state: "No answers found.",
    filters: {
        period: "Period",
        client_segments: "Client segment",
        automations: "Automation",
        read_state: "Read state",
        select_read_state: "Read and unread",
        unread: "Unread",
        read: "Read",
        tags: "Tag",
    },
    unread: "Unread",
    mark_read: "Mark as read",
    mark_all_read: "Mark all as read",
    type_emotion: "Emotion",
    type_nps: "NPS",
    type_ces: "CES",
    type_boolean: "Yes/No",
    type_comment: "Comment",
    type_input: "Text",
    type_selectbox: "Select",
    type_date: "Date",
    type_file: "File",
    type_table: "Table",
    notification_all_read: "All answers were marked as read",
    notification_marked_read: "Answer marked as read",
    notification_marked_unread: "Answer marked as unread",
    notification_read_failed: "Could not update the read status",
    message: {
        back: "Back",
        confirm_delete_title: "Are you sure you want to delete this note?",
        confirm_delete_body: "This action cannot be undone.",
        form_label: "Form",
        form_title: "Form {0}",
        filled_on: "Filled on",
        answers_report_title: "Answers Report",
        answers_title: "Answers",
        purchases_label: "Purchases",
        phone_label: "Phone",
        email_label: "Email",
        external_id_label: "External ID",
        last_purchase_label: "Last purchase",
        not_informed: "Not provided",
        spend_summary: "R$ {0} spent in {1} orders",
        no_purchase_data: "No purchase data available",
        mark_unread: "Mark as unread",
        view_client: "View client",
        more_actions: "More actions",
        edit_answers: "Edit answers",
        duplicate_answer: "Duplicate answer",
        print_answer: "Print / save PDF",
        print_client: "Customer",
        print_email: "E-mail",
        print_phone: "Phone",
        print_answered_at: "Answered at",
        print_answer_id: "Answer",
        print_footer: "Generated by Kevi",
        print_blocked: "The browser blocked the print window. Allow pop-ups for Kevi and try again.",
        delete_answer: "Delete answer",
        create_task: "Create task",
        create_task_title: "Create task from answer",
        create_task_name: "Title",
        create_task_name_placeholder: "Task title",
        create_task_board: "Board",
        create_task_board_placeholder: "None (optional)",
        create_task_stage: "Stage",
        create_task_stage_placeholder: "Select stage",
        create_task_assignee: "Assignee",
        create_task_assignee_placeholder: "Select assignee",
        create_task_due_date: "Due date",
        create_task_description: "Description",
        create_task_action: "Create task",
        create_task_default_title: "New task",
        create_task_default_description: "Client: {0}",
        confirm_delete_answer_title: "Delete this answer?",
        confirm_delete_answer_body:
            "The answer will be hidden from the list. Restoring it later requires support.",
        edit_modal_title: "Edit answers",
        duplicate_modal_title: "Duplicate answer",
        edit_save: "Save changes",
        duplicate_save: "Duplicate and save",
        notification_duplicated: "Answer duplicated successfully",
        notification_duplicate_error: "Could not duplicate the answer",
        notification_deleted: "Answer deleted",
        notification_delete_error: "Could not delete the answer",
        notification_edited: "Answers updated",
        notification_edit_error: "Could not save the changes",
        notification_task_created: "Task created successfully",
        notification_task_create_error: "Could not create the task",
        tags_label: "Tags",
        add_tag: "Add tag",
        tag_placeholder: "Select a tag or type",
        create_tag: "Create",
        tag_empty: "No tags yet. Type to create one.",
        edit_tag: "Edit tag",
        select_tag_color: "Select a color",
        delete_tag: "Delete",
        no_tags_available: "No tags configured for this form",
        notification_tag_applied: "Tag applied",
        notification_tag_removed: "Tag removed",
        notification_tag_error: "Could not update the tag",
        bool_yes: "Yes",
        bool_no: "No",
        unanswered: "Unanswered",
        no_files: "No files uploaded",
        remove_file: "Remove",
        upload_files: "Add files",
        uploading_files: "Uploading...",
        upload_files_error: "Could not upload the file",
        upload_files_too_many: "You can attach at most {0} files",
        nps_promoter: "Promoter",
        nps_neutral: "Neutral",
        nps_detractor: "Detractor",
        ces_easy: "Easy",
        ces_medium: "Acceptable",
        ces_hard: "Hard",
        linked_tasks_title: "Linked tasks",
        linked_task_open: "Open",
        linked_task_unassigned: "Unassigned",
        notes_title: "Comments",
        edit_note: "Edit comment",
        delete_note: "Delete comment",
        save: "Save",
        cancel: "Cancel",
        note_placeholder:
            "Write here what you did or plan to do regarding this feedback",
        add_note: "Comment",
        notification_note_saved: "Comment saved successfully",
        notification_note_empty: "The note cannot be empty",
        notification_note_updated: "Comment updated successfully",
        notification_note_update_error: "Error updating note",
        notification_note_deleted: "Comment deleted successfully",
        notification_note_delete_error: "Error deleting note",
        table_show_all: "Show all {0} rows",
        table_show_less: "Show less",
        table_copy: "Copy as spreadsheet",
        table_copied: "Copied",
        table_edit_unavailable: "This table can't be edited here because it was not answered.",
    },
};
